<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/149AnIh/tc-custom/9781626817937.jpg?1728954778150" alt="This image is the cover for the book Sight Unseen"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sight Unseen
      </h1>
      <p class="bookDescription body article font2">
        <b>A boy is blessed with second sight—and cursed by what he sees—in this terrifying thriller from the bestselling author of <i>The Devil’s Advocate</i>.</b><br/>  <br/> A little knowledge can be a deadly thing.<br/>  <br/> Everyone knows that David is a smart one. He can tell you the end of a story from the first sentence. The other kids won’t even go to the movies with him anymore; he always spoils the ending. People begin to wonder about David. There is, after all, such a thing as being too smart for your own good.<br/>  <br/> David has learned the hard way to keep his thoughts to himself. But now David is growing up, and his gift is turning into a power. The power to read people’s minds. To see the future. To know things—terrifying things—that he didn’t want to know. Like who would live. And who would die . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew Neiderman
      </h2>
      
      <p class="authorDescription body article">Andrew Neiderman was born in Brooklyn and grew up in New York&rsquo;s scenic Catskill Mountains region.&#160;A graduate of the University at Albany, State University of New York, from which he also received his master&rsquo;s in English, Neiderman taught at Fallsburg Junior-Senior High School for twenty-three years before pursuing a career as a novelist and screenwriter. He has written more than forty thriller novels under his own name, including&#160;<I>The Devil&rsquo;s Advocate</I>, which was made into a major motion picture for Warner Bros., starring Al Pacino, Keanu Reeves, and Charlize Theron, and is in development as a stage musical in London. Neiderman has also written seventy&#160;<I>New York Times</I>&ndash;bestselling novels for the V. C. Andrews franchise. He lives with his family in Palm Springs, California. Visit him on Facebook and at www.neiderman.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2edb177c